module.exports = __webpack_public_path__ + "img/spieltagsgewinner@2x.f6dc5234.png";